<div class="action">
    <app-popup-top-line></app-popup-top-line>
    <div class="action-header">
        <div class="title">
            {{ (isAddOwner ? "commonActions.addOwner" : "commonActions.removeOwner") | labelsProvider }}
        </div>
        <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
    </div>
    <div class="action-body">
        <div
            class="input"
            [ngClass]="{
                'search-invalid': emailControl.invalid && (emailControl.dirty || emailControl.touched),
            }">
            <input
                class="search-input"
                type="text"
                [formControl]="emailControl"
                placeholder="{{
                    (isAddOwner ? 'commonActions.addOwnerAction.newOwnerEmail' : 'commonActions.removeOwnerAction.ownerEmailToRemove')
                        | labelsProvider
                }}"
                (keyup.enter)="addOrRemoveOwnerClicked()" />
        </div>
        <div class="input-invalid-message" *ngIf="emailControl.invalid && (emailControl.dirty || emailControl.touched)">
            {{ "formErrors.emailFormFieldMsg" | labelsProvider }}
        </div>

        <mat-checkbox class="open-platform" [checked]="openPlatform" (change)="openPlatform = !openPlatform">{{
            "commonActions.addOwnerAction.openPlatformOnSuccess" | labelsProvider
        }}</mat-checkbox>

        <div class="disclaimer">
            {{ "commonActions.addOwnerAction.disclaimer" | labelsProvider }}
        </div>
    </div>
    <div class="action-footer">
        <div class="cancel" (click)="closeWindow()">Cancel</div>
        <div
            class="confirm"
            (click)="addOrRemoveOwnerClicked($event)"
            [ngClass]="{
                'confirm-disabled': emailControl.invalid || waitingForResponse,
            }">
            <span *ngIf="!waitingForResponse">{{
                isAddOwner ? ("commonActions.addOwner" | labelsProvider) : ("commonActions.removeOwner" | labelsProvider)
            }}</span>
            <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate"> </mat-progress-spinner>
        </div>
    </div>
</div>
